import { toQuery } from '@/utils/infrastructure';
import request from '@/utils/infrastructure/communication/request';

export async function queryList(params) {
  return request('/actionApiCallSendMapping/paged', {
    params: toQuery(params),
  });
}

export async function queryEditItemApiCallSend({ id, params }) {
  return request(`/actionApiCallSendMapping/${id}`, {
    params: toQuery(params),
  });
}

export async function queryAddNewApiCallSend(params) {
  return request.post(`/actionApiCallSendMapping`, {
    data: params,
  });
}

export async function queryAddEditApiCallSend(params) {
  return request.put('/actionApiCallSendMapping', {
    data: params,
  });
}

export async function queryDeleteItem(id) {
  return request.delete(`/actionApiCallSendMapping/${id}`, {});
}
